<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{ $t('restaurantSale.table') }} {{ data.table_no }}
        </h4>
      </div>
    </ts-card>
    <form>
      <ts-card-wrapper>
        <div class="form-group">
          <label class="col-form-label control-label required">{{
            $t('restaurantSale.numberOfCustomer')
          }}</label>
          <div>
            <input
              ref="num_customer"
              type="number"
              class="form-control form-control-lg"
              v-model.number="model.num_customer"
              autofocus
            />
            <small
              >{{ $t('restaurantSale.note') }}:
              {{ data.num_pax_order_book_status }}</small
            >
          </div>
        </div>
      </ts-card-wrapper>
      <div class="btn-row">
        <ts-button
          type="submit"
          color="primary"
          class="btn-block"
          @click.prevent="startOrder"
          :disabled="model.num_customer > 0 ? false : true"
          ><i class="fas fa-cart-plus"></i>
          {{ $t('restaurantSale.order') }}</ts-button
        >
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: ['data'],
  name: 'input-number-customer-form',
  data () {
    return {
      model: {
        num_customer: null
      }
    }
  },
  mounted () {
    this.$refs.num_customer.focus()
  },
  methods: {
    startOrder () {
      this.$store.commit(
        'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
        this.data
      )
      this.$store.commit(
        'restaurantSale/counterCheckout/SET_NUMBER_CUSTOMERS',
        this.model.num_customer
      )
      this.$emit('close')
      this.$emit('before-close')
      this.$router.push({ name: 'customer-order' })
    }
  }
}
</script>
<style scoped>
.btn-row .btn {
  padding: 15px 20px;
  font-size: 0.875rem;
  min-width: 100px;
  text-align: center;
  position: relative;
  border-radius: 0;
}
</style>
